<template>
    <v-card color="lighten-5" flat>
        <v-card-title class="grey lighten-3">
            <h4 class="topic">Instalação</h4>
        </v-card-title>
        <p class="info-color mt-3">Complete as informações</p>
        <v-textarea class="mt-2" outline placeholder="Inserir informações complementares" no-resize counter rows="4"
            v-model="projeto.informacoesInstalacao">
        </v-textarea>
        <v-card class="white--text px-2 py-3" color="#0083CA" flat>
            <v-layout align-center>
                <v-flex xs3>
                    <v-img :src="infoImage" aspect-ratio="1.5" width="5rem" contain class="image-info"></v-img>
                </v-flex>
                <v-flex class="px-0" xs8>
                    <p class="text-center" style="font-size: 12px;">
                        A Aldo Solar não se responsabiliza pela instalação, projeto e acompanhamento junto a operadora.
                    </p>
                </v-flex>                
            </v-layout>           
        </v-card>        
    </v-card>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ProjectInstallation",        
        computed: mapGetters(['projeto']),       
        data() {
            return {
                infoImage: require("./icons/info.svg")  
            }
        }
    }
</script>

<style scoped>

</style>
